import { type TCollectionDownloadUnsuccessReason } from '@core/analytics'
import { HttpStatusCode, isHttpError } from '@core/http-client'

import { CollectionDownloadTimeoutError } from './collectionDownloadErrors'

type TCollectionDownloadFailure = {
    reason: TCollectionDownloadUnsuccessReason
    status: number
    messageKey:
        | 'i18n.collectionDownloadTimeout'
        | 'i18n.collectionDownloadPrepareError'
        | 'i18n.collectionDownloadForbidden'
        | 'i18n.collectionDownloadEmpty'
}

export const describeCollectionDownloadFailure = (error: unknown): TCollectionDownloadFailure => {
    if (error instanceof CollectionDownloadTimeoutError) {
        return {
            reason: 'timeout',
            status: HttpStatusCode.ACCEPTED,
            messageKey: 'i18n.collectionDownloadTimeout',
        }
    }

    // Zero, not absent: the attempt never reached a response, and the axis has to keep its position.
    if (!isHttpError(error)) {
        return { reason: 'unknown', status: 0, messageKey: 'i18n.collectionDownloadPrepareError' }
    }

    const { status } = error.response

    if (status === HttpStatusCode.NOT_FOUND) {
        return { reason: 'not_found', status, messageKey: 'i18n.collectionDownloadForbidden' }
    }

    if (status === HttpStatusCode.GONE) {
        return { reason: 'no_audios', status, messageKey: 'i18n.collectionDownloadEmpty' }
    }

    return { reason: 'http_error', status, messageKey: 'i18n.collectionDownloadPrepareError' }
}
